// extracted by mini-css-extract-plugin
export var sliderRange = "_s5-2";
export var sliderRoot = "_s5-0";
export var sliderThumb = "_s5-3";
export var sliderTrack = "_s5-1";